import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  appBar: {
    borderRadius: 15,
    margin: "30px 0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 50px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  brandContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {},
  },
  heading: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "3rem",
    },
  },
  image: {
    marginRight: "15px",
    height: "4rem",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  toolbar: {
    display: "flex",
    justifyContent: "flex-end",
    width: "400px",
  },
  profile: {
    display: "flex",
    justifyContent: "space-between",
    width: "400px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "10px",
      flexDirection: "column",
      alignItems: "center",
    },
  },
  userInfo: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  userName: {
    display: "flex",
    alignItems: "center",
    margin: "5px 0 5px 10px",
  },
  logout: {
    // borderRadius: 15,
  },
  purple: {
    color: theme.palette.white.main,
    backgroundColor: theme.palette.primary.main,
    // borderRadius: 15,
  },
}));
